export const FETCH_FLEX_META_DATA_LABELS_REQUEST = "FETCH_FLEX_META_DATA_LABELS_REQUEST";
export const FETCH_FLEX_META_DATA_LABELS_SUCCESS = "FETCH_FLEX_META_DATA_LABELS_SUCCESS";
export const FETCH_FLEX_META_DATA_LABELS_FAILURE = "FETCH_FLEX_META_DATA_LABELS_FAILURE";
